const map = {
	"./ACA-Marca-RGB.ai_-1536x560.png": "./src/assets/images/ACA-Marca-RGB.ai_-1536x560.png",
	"./Grupo 5774.zip": "./src/assets/images/Grupo 5774.zip",
	"./Grupo-5774.png": "./src/assets/images/Grupo-5774.png",
	"./Grupo-5774.svg": "./src/assets/images/Grupo-5774.svg",
	"./Render-1-scaled.jpg": "./src/assets/images/Render-1-scaled.jpg",
	"./Render-1-scaled2.jpg": "./src/assets/images/Render-1-scaled2.jpg",
	"./angular.jpg": "./src/assets/images/angular.jpg",
	"./arrow-down.png": "./src/assets/images/arrow-down.png",
	"./avatars/1.jpg": "./src/assets/images/avatars/1.jpg",
	"./avatars/2.jpg": "./src/assets/images/avatars/2.jpg",
	"./avatars/3.jpg": "./src/assets/images/avatars/3.jpg",
	"./avatars/4.jpg": "./src/assets/images/avatars/4.jpg",
	"./avatars/5.jpg": "./src/assets/images/avatars/5.jpg",
	"./avatars/6.jpg": "./src/assets/images/avatars/6.jpg",
	"./avatars/7.jpg": "./src/assets/images/avatars/7.jpg",
	"./avatars/8.jpg": "./src/assets/images/avatars/8.jpg",
	"./avatars/9.jpg": "./src/assets/images/avatars/9.jpg",
	"./check.png": "./src/assets/images/check.png",
	"./circle-amarillo.png": "./src/assets/images/circle-amarillo.png",
	"./circle-azul.png": "./src/assets/images/circle-azul.png",
	"./circle-gris.png": "./src/assets/images/circle-gris.png",
	"./circle-naranja.png": "./src/assets/images/circle-naranja.png",
	"./circle-rojo.png": "./src/assets/images/circle-rojo.png",
	"./circle-verde.png": "./src/assets/images/circle-verde.png",
	"./circle-violeta.png": "./src/assets/images/circle-violeta.png",
	"./circle.png": "./src/assets/images/circle.png",
	"./circle1.png": "./src/assets/images/circle1.png",
	"./comprobar.png": "./src/assets/images/comprobar.png",
	"./down-arrowhead-in-a-circle.png": "./src/assets/images/down-arrowhead-in-a-circle.png",
	"./editar.png": "./src/assets/images/editar.png",
	"./hide.png": "./src/assets/images/hide.png",
	"./icon-imagen-upload.png": "./src/assets/images/icon-imagen-upload.png",
	"./icon-imagen-upload1.png": "./src/assets/images/icon-imagen-upload1.png",
	"./icon-imagen-upload2.png": "./src/assets/images/icon-imagen-upload2.png",
	"./image-perfil.png": "./src/assets/images/image-perfil.png",
	"./init.png": "./src/assets/images/init.png",
	"./logo-cog.png": "./src/assets/images/logo-cog.png",
	"./logo-cognitive.png": "./src/assets/images/logo-cognitive.png",
	"./logo-cognitive_old.png": "./src/assets/images/logo-cognitive_old.png",
	"./logo-new.png": "./src/assets/images/logo-new.png",
	"./logo-new2.png": "./src/assets/images/logo-new2.png",
	"./logoa.png": "./src/assets/images/logoa.png",
	"./logoa2.png": "./src/assets/images/logoa2.png",
	"./logoacya-white.png": "./src/assets/images/logoacya-white.png",
	"./logoacya-white2 (2).png": "./src/assets/images/logoacya-white2 (2).png",
	"./logoacya-white2.png": "./src/assets/images/logoacya-white2.png",
	"./logoacya-white3.png": "./src/assets/images/logoacya-white3.png",
	"./logoacya-white8.png": "./src/assets/images/logoacya-white8.png",
	"./logoacya-whitem.png": "./src/assets/images/logoacya-whitem.png",
	"./logoacya-whitem2.png": "./src/assets/images/logoacya-whitem2.png",
	"./logoacya-whiten.png": "./src/assets/images/logoacya-whiten.png",
	"./logoacya.PNG": "./src/assets/images/logoacya.PNG",
	"./logoacya3.png": "./src/assets/images/logoacya3.png",
	"./logoacya55.png": "./src/assets/images/logoacya55.png",
	"./logoacya552.png": "./src/assets/images/logoacya552.png",
	"./logoacya5521.png": "./src/assets/images/logoacya5521.png",
	"./logoacya552n.png": "./src/assets/images/logoacya552n.png",
	"./logoacya556.png": "./src/assets/images/logoacya556.png",
	"./logoacya557.png": "./src/assets/images/logoacya557.png",
	"./logoacya5571.png": "./src/assets/images/logoacya5571.png",
	"./logoacya557n.png": "./src/assets/images/logoacya557n.png",
	"./logoan.png": "./src/assets/images/logoan.png",
	"./movie.png": "./src/assets/images/movie.png",
	"./play.png": "./src/assets/images/play.png",
	"./react.jpg": "./src/assets/images/react.jpg",
	"./reset.png": "./src/assets/images/reset.png",
	"./ruta-nacional4 - copia (2).png": "./src/assets/images/ruta-nacional4 - copia (2).png",
	"./ruta-nacional4 - copia.png": "./src/assets/images/ruta-nacional4 - copia.png",
	"./ruta-nacional4.png": "./src/assets/images/ruta-nacional4.png",
	"./stop.png": "./src/assets/images/stop.png",
	"./trash.png": "./src/assets/images/trash.png",
	"./up-arrowhead-in-a-circle.png": "./src/assets/images/up-arrowhead-in-a-circle.png",
	"./view.png": "./src/assets/images/view.png",
	"./vue.jpg": "./src/assets/images/vue.jpg",
	"./.zip": "./src/assets/images/.zip",
	"./ (1).zip": "./src/assets/images/ (1).zip",
	"./@2x.png": "./src/assets/images/@2x.png",
	"./.zip": "./src/assets/images/.zip"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/.*$";